import React from 'react'
import PieChart from 'highcharts-react-official'
import Highcharts from 'highcharts/highcharts'

Highcharts.setOptions({ lang: { thousandsSep: ',' } });

// กราฟ stacked แบบใช้ร่วม — รับ categories + series ที่ pivot มาแล้ว
export default function StackedBarChart({ categories, series, horizontal, height, showLegend = true, showDataLabels = false, unit = 'กิโลกรัม' }) {
    const options = {
        chart: {
            type: horizontal ? 'bar' : 'column',
            height: height || 400,
        },
        title: { text: '' },
        subtitle: { text: `หน่วย : ${unit}`, align: 'left' },
        xAxis: {
            categories: categories,
            title: null,
        },
        yAxis: {
            min: 0,
            title: null,
            stackLabels: { enabled: false },
            labels: {
                formatter: function () {
                    return this.value?.toLocaleString();
                }
            },
        },
        legend: { enabled: showLegend },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormatter: function () {
                return `${this.series.name}: <b>${this.y?.toLocaleString()}</b><br/>`
            }
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                borderWidth: 0,
                dataLabels: {
                    enabled: showDataLabels,
                    color: '#fff',
                    style: { fontWeight: 'bolder', textOutline: 'none', fontSize: '10px' },
                    formatter: function () {
                        return this.y > 0 ? this.y?.toLocaleString() : null
                    }
                }
            }
        },
        series: series,
    }

    return (
        <PieChart options={options} highcharts={Highcharts} />
    )
}
